"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryEncryptionAdapters = void 0;

var _common = require("../common");

var _BasisTheoryEncryption = require("./BasisTheoryEncryption");

class BasisTheoryEncryptionAdapters {
  constructor() {
    if (typeof window === 'undefined') {
      this._nodeEncryption = new _BasisTheoryEncryption.BasisTheoryEncryption('NODE');
    } else {
      this._browserEncryption = new _BasisTheoryEncryption.BasisTheoryEncryption('BROWSER');
    }
  } // eslint-disable-next-line accessor-pairs


  get browserEncryption() {
    return (0, _common.assertInit)(this._browserEncryption);
  } // eslint-disable-next-line accessor-pairs


  get nodeEncryption() {
    return (0, _common.assertInit)(this._nodeEncryption);
  }

}

exports.BasisTheoryEncryptionAdapters = BasisTheoryEncryptionAdapters;